import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../services/api";
import CheesecakeFormModal from "./CheesecakeFormSections/CheesecakeFormModal";
import CheesecakeTable from "./CheesecakeTable";

const Cheesecakes = () => {
  const [cheesecakes, setCheesecakes] = useState([]);
  const [selectedCheesecake, setSelectedCheesecake] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchCheesecakes();
  }, []);

  const fetchCheesecakes = async () => {
    try {
      const response = await api.get("/cheesecakes");
      setCheesecakes(response.data);
    } catch (error) {
      console.error("Error fetching cheesecakes:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cheesecakes/${id}`);
      setCheesecakes((prev) => prev.filter((c) => c._id !== id));
    } catch (error) {
      console.error("Error deleting cheesecake:", error);
    }
  };

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Manage Cheesecakes
        </Typography>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => setIsModalOpen(true)}
          sx={{
            borderColor: "#FD7762",
            color: "#FD7762",
            textTransform: "none",
            "&:hover": {
              borderColor: "#e46052",
              backgroundColor: "#fff0ee",
            },
          }}>
          Add Cheesecake
        </Button>
      </Stack>

      <CheesecakeTable
        data={cheesecakes}
        onDelete={handleDelete}
        onEdit={(cheesecake) => {
          setSelectedCheesecake(cheesecake);
          setIsModalOpen(true);
        }}
      />

      {isModalOpen && (
        <CheesecakeFormModal
          onClose={() => {
            setIsModalOpen(false);
            setSelectedCheesecake(null);
          }}
          onSave={fetchCheesecakes}
          cheesecake={selectedCheesecake}
        />
      )}
    </Box>
  );
};

export default Cheesecakes;
